import React, { useState, useEffect } from "react";
import GridExplore from "../components/ExploreOurCourses/GridExplore";
import ListExplore from "../components/ExploreOurCourses/ListExplore";
import ListIcon from "../assets/ExploreOurCourses/listIcon.png";
import gridIcon from "../assets/ExploreOurCourses/gridIcon.png";
import filterIcon from "../assets/ExploreOurCourses/filterIcon.png";
import SectionHeading from "../components/shared/SectionHeading";
import FilterModal from "../components/ExploreOurCourses/FilterModal";
import axios from "axios";

const ExploreOurCourses = () => {
  const [defaultFilterOptions, setDefaultFilterOptions] = useState({
    level: [],
    category: [],
    duration: [],
    eligibility: [],
  });
  const [toggle, setToggle] = useState("grid"); // "grid" or "list" view
  const [isOpen, setIsOpen] = useState(false); // Filter modal visibility
  const [courses, setCourses] = useState([]); // Fetched courses
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(null); // Active filters (null means no filters)
  const [isMobile, setIsMobile] = useState(false);

  const fetchFilterOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/course-categories`
      );
      const formattedOptions = {
        level: response.data.levels || [],
        category: response.data.categories || [],
        duration: response.data.durations || [],
        eligibility: response.data.eligibilities || [],
      };

      setDefaultFilterOptions(formattedOptions);
      console.log("Filter options fetched:", formattedOptions);
      console.log("Filter options fetched:", defaultFilterOptions);
    } catch (error) {
      console.error("Error fetching filter options:", error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch courses from the backend
  const fetchCourses = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(filters).toString();
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/program?${queryParams}`
      );

      setCourses(response.data || []);
    } catch (error) {
      setLoading(true);
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilterOptions();
    fetchCourses();
  }, []);

  useEffect(() => {
    if (filters !== null) {
      fetchCourses();
    }
  }, [filters]);

  // Handle filter application
  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters); // Set filters and trigger fetch
    setIsOpen(false); // Close the filter modal
  };

  return (
    <div className="mx-auto mb-12 max-w-[1380px] px-4 sm:px-6 lg:px-8">
      <div className="w-full mx-auto pt-4">
        <div className="flex justify-center items-center mt-6 mb-6">
          <SectionHeading>
            <span className="text-secondary-color">Explore Our </span>
            <span className="text-primary-color">Courses</span>
          </SectionHeading>
        </div>

        <div className="justify-between items-center py-4 sm:py-6 p-2 sm:p-4 flex flex-col sm:flex-row gap-4 sm:gap-0">
          <div className="w-full flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
            {/* Filter Modal - Always present but hidden on desktop */}
            <div className="w-full sm:w-auto">
              <FilterModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onApply={handleApplyFilters}
                filterOptions={defaultFilterOptions}
                isMobile={isMobile}
              />
            </div>

            {/* Mobile and Medium View - List/Card Toggle and Filter Button */}
            <div className="w-full flex justify-between items-center md:hidden">
              {/* List/Card Toggle Buttons - Left Side */}
              <div className="flex items-center border rounded-lg">
                <button
                  className="p-2 rounded-lg rounded-r-none flex items-center hover:bg-gray-100 transition-colors"
                  style={{
                    boxShadow:
                      toggle === "list"
                        ? "inset 0 2px 4px rgba(0, 0, 0, 0.3)"
                        : "none",
                  }}
                >
                  <img
                    src={ListIcon}
                    alt="list"
                    className="h-5 w-5 cursor-pointer"
                    onClick={() => setToggle("list")}
                  />
                </button>
                <button
                  className="p-2 rounded-lg rounded-l-none flex items-center hover:bg-gray-100 transition-colors"
                  style={{
                    boxShadow:
                      toggle === "grid"
                        ? "inset 0 2px 4px rgba(0, 0, 0, 0.3)"
                        : "none",
                  }}
                >
                  <img
                    src={gridIcon}
                    alt="grid"
                    className="h-5 w-5 cursor-pointer"
                    onClick={() => setToggle("grid")}
                  />
                </button>
              </div>

              {/* Filter Button - Right Side */}
              <button
                onClick={() => setIsOpen(true)}
                className="border p-2 rounded-lg flex items-center justify-center gap-2 hover:bg-gray-100 transition-colors"
              >
                <img
                  src={filterIcon}
                  alt="filter"
                  className="h-5 w-5"
                />
                <span className="text-sm">Filters</span>
              </button>
            </div>

            {/* Desktop View - List/Card Toggle */}
            <div className="hidden md:flex items-center border rounded-lg">
              <button
                className="p-2 rounded-lg rounded-r-none flex items-center hover:bg-gray-100 transition-colors"
                style={{
                  boxShadow:
                    toggle === "list"
                      ? "inset 0 2px 4px rgba(0, 0, 0, 0.3)"
                      : "none",
                }}
              >
                <img
                  src={ListIcon}
                  alt="list"
                  className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                  onClick={() => setToggle("list")}
                />
              </button>
              <button
                className="p-2 rounded-lg rounded-l-none flex items-center hover:bg-gray-100 transition-colors"
                style={{
                  boxShadow:
                    toggle === "grid"
                      ? "inset 0 2px 4px rgba(0, 0, 0, 0.3)"
                      : "none",
                }}
              >
                <img
                  src={gridIcon}
                  alt="grid"
                  className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                  onClick={() => setToggle("grid")}
                />
              </button>
            </div>
          </div>
        </div>

        {loading === false ? (
          <div className="relative">
            {toggle === "list" ? (
              <ListExplore courses={courses} />
            ) : (
              <GridExplore data={courses} />
            )}
          </div>
        ) : (
          <div className="flex justify-center items-center min-h-[200px]">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-color"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExploreOurCourses;
